<template>
	<LayoutBreadcrumbs v-if="slug?.length && !isBlogStory" class="main-wrapper" />

	<StoryblokComponent v-if="story" :blok="story.content" />
</template>

<script setup lang="ts">
import { fetchStoryblokContentByFolder } from "~/utils/storyblok/fetchStoryblokContentByFolder";

const { slug } = useRoute().params;
const { t } = useI18n();
const storyblokLanguage = useStoryblokLanguage();
const { setPageType } = usePageStore();
const {
	public: { categoryContentKey, storyblokVersion }
} = useRuntimeConfig();
const { helloRetailTrack } = useHelloRetailTracking();
const storyblokApi = useStoryblokApi();

const isCategoryContent = Array.isArray(slug)
	? slug.includes(categoryContentKey)
	: slug === categoryContentKey;

if (isCategoryContent) {
	useSeoMeta({
		robots: "noindex, nofollow"
	});
}

const path =
	slug && Array.isArray(slug) && slug.length > 0 ? slug.join("/") : "home";
const story = ref();
useStoryblokBridgeStory(story, { resolveLinks: "url" });

const { data: fetchedStory } = await useAsyncData(
	`cms-story-${path}-${storyblokLanguage.value}`,
	async () => {
		try {
			const { data } = await fetchStoryblokContentByFolder(
				storyblokApi,
				path,
				{
					version: storyblokVersion,
					language: storyblokLanguage.value,
					resolve_links: "url"
				},
				{ folders: [] }
			);
			return data.story ?? null;
		} catch {
			return null;
		}
	}
);

if (!fetchedStory.value) {
	showError({
		statusCode: 404,
		statusMessage: t("errors.page_not_found.title"),
		message: t("errors.page_not_found.message")
	});
}

story.value = fetchedStory.value;

const isBlogStory = computed(() =>
	isBlogStoryComponent(story.value?.content?.component)
);

if (story.value) {
	if (!slug?.length) {
		setPageType("home");
	} else {
		setPageType("cms");
	}
}
useCmsSeoMeta(story.value);

useCmsSchemaOrg(story.value);

onMounted(() => {
	helloRetailTrack({
		serviceType: "pageview",
		trackingData: {
			location: window.location.href,
			referrer: window.location.origin,
			url: window.location.href
		}
	});
});
</script>
